import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ConfirmationMessage from "../../../components/confirmationMessage"
import ClientGSSView from "./ClientGSSView";
import {ClientGSSService} from "../../../service/maintenance/clientGSS/ClientGSSService";
import {Button} from "primereact/button";
import ContextMenu from "../../../components/contextMenu";
import {deleteNonNumericPint} from "../../../utils/formatters/Accent";

export default class ClientGSSContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }
        this.clientGSSService = new ClientGSSService();
        this.openConfirmationDelete = this.openConfirmationDelete.bind(this);
        this.getDataClientGSS = this.getDataClientGSS.bind(this);

        this.state = {
            dataClientsGSS: this.getDataClientGSS(),
            clientSelected: '',
            isLoading: true,
            newClient: false,
            clientGSS: {
                idRelCliente: "",
                nomRel: "",
            },
        };

        this.updateClientGSS = this.updateClientGSS.bind(this);
        this.deleteClientGSS = this.deleteClientGSS.bind(this);
        this.clientGSSOrderActionTemplate = this.clientGSSOrderActionTemplate.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.openDialogAdd = this.openDialogAdd.bind(this);
        this.openDialogEdit = this.openDialogEdit.bind(this);
        this.onChangeTextDialog = this.onChangeTextDialog.bind(this);
        this.handleSelectClient = this.handleSelectClient.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que cierra el cuadro de diálogo de editar o agregar un nuevo cliente.
     */
    onHideDialog() {
        this.setState({
            displayDialog: false,
            clientSelected: {
                idRelCliente: "",
                nomRel: "",
            },
            clientGSS: {
                idRelCliente: "",
                nomRel: "",
            },
        });
    }

    /**
     * Función que abre el cuadro de diálogo para editar, se especifica que
     * no es un nuevo cliente, entonces se va a editar.
     */
    openDialogEdit() {
        let dataSelected = JSON.parse(JSON.stringify(this.state.clientSelected));
        this.setState({
            newClient: false,
            displayDialog: true,
            clientGSS: dataSelected,
        });
    }

    /***
     * Función que abre el cuadro de diálogo para agregar, se especifica
     * que es un nuevo cliente.
     */
    openDialogAdd() {
        this.setState({
            newClient: true,
            displayDialog: true,
            clientGSS: {
                idRelCliente: "",
                nomRel: "",
            },
        });
    }

    /**
     * Función que abre el mensaje de confirmación para borrar un registro de la tabla.
     * Guarda el elemento a eliminar en una variable del estado.
     */
    openConfirmationDelete() {
        if (this.state.clientSelected) {
            let selectedClientAux = this.state.clientSelected;
            this.setState({clientGSS: selectedClientAux});
            if (this.confirmationRef) {
                this.confirmationRef.openConfirmationMessage()
            }
        }
    }

    /**
     * Función que maneja el cambio de los cuadros de texto en el pop up
     * de editar y agregar. Coloca el valor que obtiene en una variable de estado.
     * @param event Contiene los datos que vienen de la vista.
     */
    onChangeTextDialog(event) {
        const {id, value} = event.target;
        let clientGSS = this.state.clientGSS;
        clientGSS[id] = id === 'idRelCliente' ? deleteNonNumericPint(value) : value;
        this.setState({clientGSS: clientGSS,})
    }

    /**
     * Función que coloca el objeto cliente que se selecciona en la vista para
     * ponerlo en una variable y posteriormente editarlo o eliminarlo.
     * @param event Contiene los datos que vienen de la vista.
     */
    handleSelectClient = (event) => {
        this.setState({
            clientSelected: event.value,
        });
    };

    /**
     * Función que consume un servicio web (ClientGSSService) del que obtiene la
     * lista de clientes que se presenta en la tabla de la pantalla.
     * @returns {Promise<unknown>} Lista de clientes.
     */
    getDataClientGSS() {
        this.loading();
        return this.clientGSSService.getDataClientGSS()
            .then(dataClientsGSS =>
                this.setState({
                    dataClientsGSS: dataClientsGSS,
                    isLoading: false,
                })
            )
    }

    /**
     * Función que agrega un nuevo cliente o que edita el cliente seleccionado.
     * Va al servicio ClientGSSService, para guardar la información.
     */
    updateClientGSS() {
        if (("" !== this.state.clientGSS.idRelCliente) &&
            (this.state.clientGSS.idRelCliente !== '0') &&
            ("" !== this.state.clientGSS.nomRel)) {
            this.loading();
            this.clientGSSService.updateClientGSS(this.state.clientGSS.idRelCliente,
                this.state.clientGSS.nomRel).then((resp) => {
                    this.getDataClientGSS();
                    if (resp.message === "Success" || resp.message === "true") {
                        this.growl.show({
                            severity: 'success', summary: 'Atención.',
                            detail: 'La información se actualizó correctamente.'
                        });
                    } else if (resp.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: resp.error
                        });
                    }

                    this.setState({
                        clientGSS: {
                            idRelCliente: "",
                            nomRel: "",
                        },
                        clientSelected: {
                            idRelCliente: "",
                            nomRel: "",
                        },
                        isLoading: false,
                    });
                }
            );
            this.onHideDialog();
        } else {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Llenar correctamente los campos obligatorios.'
            });
        }
    }

    /**
     * Función que elimina el cliente seleccionado de la tabla.
     * Va al servicio ClientGSSService, para eliminar en base de datos.
     */
    deleteClientGSS() {
        this.loading();
        this.clientGSSService.deleteClientGSS(this.state.clientGSS.idRelCliente,
            this.state.clientGSS.nomRel).then(() => {
                this.getDataClientGSS();
                this.setState({
                    clientGSS: {
                        idRelCliente: "",
                        nomRel: "",
                    },
                    clientSelected: {
                        idRelCliente: "",
                        nomRel: "",
                    },
                    isLoading: false,
                })
            }
        );
    }

    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    clientGSSOrderActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar", action: this.openDialogEdit},
            {label: "Eliminar", action: this.openConfirmationDelete},
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6">
                    <h2 className={"secondary-text"}>{this.state.newClient ? "Agregar" : "Editar"}</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3">
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3">
                    <Button label="Guardar" onClick={this.updateClientGSS}/>
                </div>
            </div>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Desea eliminar el cliente seleccionado?"
                                            action={this.deleteClientGSS}/>;
        const {dataClientsGSS, displayDialog, isLoading, clientGSS, newClient, clientSelected} = this.state;

        return <ClientGSSView dataClientsGSS={dataClientsGSS}
                              clientGSS={clientGSS}
                              displayDialog={displayDialog}
                              dialogHeader={dialogHeader}
                              isLoading={isLoading}
                              messagesGrowl={messagesGrowl}
                              newClient={newClient}
                              clientSelected={clientSelected}
                              confirmationMsg={this.confMsg}
                              getDataClientGSS={this.getDataClientGSS}
                              onHideDialog={this.onHideDialog}
                              openDialogAdd={this.openDialogAdd}
                              onChangeTextDialog={this.onChangeTextDialog}
                              clientGSSOrderActionTemplate={this.clientGSSOrderActionTemplate}
                              handleSelectClient={this.handleSelectClient}/>
    }
};